// ERT 서비스 기준 데이터테이블 헤더/바디의 셀 스타일 기본 옵션
export const data_table_cell_style = {
  borderWidth: '1',
  borderType: 'solid',
  borderColor: '#dedede',
  backgroundColor: '#ffffff',
  borderSide: [1, 1, 0, 0],
  textAlign: 'start',
  verticalAlign: 'top',
  colspan: 1,
  rowspan: 1,
  hidden: 0,
  width: 'auto'
};

export const data_table_header_style = {
  borderWidth: '1',
  borderType: 'solid',
  borderColor: '#a2a2a2',
  backgroundColor: '#EFEFEF',
  borderSide: [1, 1, 0, 0],
  textAlign: 'start',
  verticalAlign: 'top',
  width: 'auto'
};

export const basic_data_table_cell_style = {
  borderWidth: '1',
  borderType: 'solid',
  borderColor: '#dedede',
  backgroundColor: '#ffffff',
  borderSide: [1, 1, 0, 0],
  textAlign: 'start',
  verticalAlign: 'top',
  verticalPadding: '0.25',
  horizontalPadding: '0.75',
  colspan: 1,
  rowspan: 1,
  hidden: 0,
  width: 'auto'
};

export const basic_data_table_header_style = {
  borderWidth: '1',
  borderType: 'solid',
  borderColor: '#a2a2a2',
  backgroundColor: '#EFEFEF',
  borderSide: [1, 1, 0, 0],
  textAlign: 'start',
  verticalAlign: 'top',
  verticalPadding: '0.25',
  horizontalPadding: '0.75',
  width: 'auto'
};
